import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RestfullApiService } from "../../config/service";
import { decryptData, encryptData } from "../../utils/storage";
import PreLoader from "../../utils/PreLoader";
import { MEDIA_URL } from "../../config/url";
import { useSelector } from "react-redux";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import toast from "react-hot-toast";

function CategoryBlog() {
  const [fetchingBlog, setFetchingBlog] = useState(false);
  const [blogDetails, setBlogDetails] = useState([]);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const user = useSelector((state) => state.user.userProfile);
  const navigate = useNavigate();
  const { blog_id } = useParams();
  const handlePageShareLink = async () => {
    try {
      const url = window.location.href;
      console.log(url);
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard!");
    } catch (error) {
      toast.error("Failed to copy link.");
    }
  };
  const shareContent = async () => {
    const url = window.location.href;
    const message = `Check out this event: ${url}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this awesome content!",
          text: message, // Full message including the URL
          // Omitting url property
        });
        console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      console.log("Share API not supported");
      // Optionally provide a fallback here
    }
  };
  async function loadEvent(Blog_Id) {
    const reqdata = {
      Method_Name: "Getone",
      Org_Id: user?.Org_Id ? user?.Org_Id : "NA",
      Session_User_Id: user?.Participant_Id ? user?.Participant_Id : "NA",
      Session_User_Name: user ? `${user?.First_Name} ${user?.Last_Name}` : "NA",
      Blog_Id: Blog_Id,
      Filter: "",
    };
    try {
      setFetchingBlog(true);
      const result = await RestfullApiService(reqdata, "participant/blogs");
      if (result) {
        return result;
      }
    } catch (err) {
      alert(err);
    } finally {
      setFetchingBlog(false);
    }
  }
  useEffect(() => {
    async function fetchBlogDetails() {
      const decrypted = decryptData(blog_id);
      const response = await loadEvent(decrypted);

      if (response) {
        console.log(response?.data?.Result);

        setBlogDetails(response?.data?.Result?.Table1[0]);
        setRecentBlogs(response?.data?.Result?.Table2);
      }
    }

    if (blog_id) {
      fetchBlogDetails();
    }
  }, [blog_id]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {fetchingBlog && <PreLoader />}
      {!fetchingBlog && (
        <>
          <section
            style={{ marginTop: "90px" }}
            className="py-5 d-flex items-center bg-blue-1-05"
          >
            <div className="container">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1 font-inter">
                    <div className="col-auto">
                      <a href="/" className="cursor-pointer">
                        Home
                      </a>
                    </div>
                    <div className="col-auto">
                      <div className="">{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary cursor-pointer">
                        Blog Details
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-20">
            <div className="container">
              <div className="row pt-30 gy-5">
                <div className="col-md-8 relative d-flex flex-column">
                  <img
                    src={`${MEDIA_URL}${blogDetails.Image_Path}`}
                    alt="Banner"
                    className="rounded-16 col-12 blog-img"
                  />
                  <div className="row y-gap-30 col-12">
                    <div className="col-12">
                      <div className="row y-gap-20">
                        <div id="overview" className="col-12">
                          <h3 className="text-25 fw-600 pt-20">
                            {blogDetails?.Short_Description}
                          </h3>
                        </div>
                        <div className="row x-gap-20 font-inter">
                          <div className="col-auto">
                            <div className="text-left d-flex items-center py-10 x-gap-10">
                              <i className="far fa-calendar text-20 fw-600 text-primary"></i>
                              <div
                                className="text-14 fw-600 lh-1"
                                style={{ color: "#0E0E0E" }}
                              >
                                {blogDetails?.Created_On}
                              </div>
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="text-left d-flex items-center py-10 x-gap-10">
                              <i className="fas fa-running text-18 fw-600 text-primary"></i>
                              <div
                                className="text-14 fw-600 lh-1"
                                style={{ color: "#0E0E0E" }}
                              >
                                {blogDetails?.BlogType}
                              </div>
                            </div>
                          </div>
                        </div>
                        <p className="text-dark-1 text-14 lh-2 font-inter text-reading fw-500 text-justify">
                          {blogDetails?.Long_Description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="px-15 py-15 border-light rounded-16">
                    <h3 className="text-20 fw-600">Recent Blogs</h3>
                    <div className="d-flex flex-column gap-25 mt-25">
                      {recentBlogs?.map((blog) => {
                        const encryptedParam = encryptData(blog?.Blog_Id);

                        return (
                          <a
                            href={`/blog/${encryptedParam}`}
                            className="d-flex items-center gap-25 cursor-pointer"
                          >
                            <img
                              src={`${MEDIA_URL}${blog?.Image_Path}`}
                              // className="rounded-full object-cover border-primary"
                              style={{
                                width: "120px",
                                height: "100px",
                                borderRadius: "10px",
                                objectFit: "cover",
                              }}
                              alt="event"
                            />
                            <div className="d-flex flex-column font-inter">
                              <div className="col-auto">
                                <div className="text-left d-flex items-center py-10 x-gap-10">
                                  <i className="far fa-calendar text-20 fw-600 text-primary"></i>
                                  <div className="text-14 fw-600 lh-1 text-reading">
                                    {blog?.Created_On}
                                  </div>
                                </div>
                              </div>
                              <div className="col-auto">
                                <h3 className="text-13 fw-600">
                                  {blogDetails?.Short_Description}
                                </h3>
                              </div>
                            </div>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                  <div className="px-15 py-15 mt-25 border-light rounded-16">
                    <h3 className="text-20 fw-600">Tags</h3>
                    <div className="d-flex mt-15 js-lazy">
                      {blogDetails?.Tags?.split(",")?.map((tag) => {
                        return (
                          <div className="bg-light-2 rounded-16 text-13 fw-600 text-dark-1 py-10 px-15 lh-1 m-1 font-inter">
                            {tag}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="px-15 py-15 mt-25 border-light rounded-16">
                    <h3 className="text-20 fw-600 mb-20">Share</h3>
                    <div className="d-flex justify-start gap-25 mb-15 js-lazy rounded-8">
                      <div
                        className="fas fa-link border-dark-1 text-16 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                        onClick={handlePageShareLink}
                      ></div>
                      <LinkedinShareButton
                        url={`Check out this event:\n${window.location.href}`}
                      >
                        <div className="fab fa-linkedin border-dark-1 text-16 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"></div>
                      </LinkedinShareButton>
                      {/* <div className="fab fa-linkedin-in border-dark-1 text-18 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-50 w-50 button -primary-transparent-1"></div>
                       */}
                      <FacebookShareButton
                        url={`Check out this event:\n${window.location.href}`}
                      >
                        <div className="fab fa-facebook border-dark-1 text-16 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"></div>
                      </FacebookShareButton>
                      <div
                        onClick={() => shareContent()}
                        className="fab fa-instagram border-dark-1 text-16 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                      ></div>
                      <WhatsappShareButton
                        url={`Check out this event:\n${window.location.href}`}
                      >
                        <div
                          className="fab fa-whatsapp border-dark-1 text-16 fw-600 rounded-25 px-20 py-20 text-center cursor-pointer h-34 w-34 button -primary-transparent-1"
                          // onClick={handleWhatsappLink}
                        ></div>
                      </WhatsappShareButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-30 layout-pb-md">
            <div className="container">
              {/* <div className="row y-gap-30">
              <div className="col-xl-8">
                <div className="row y-gap-20">
                  <div id="overview" className="col-12">
                    <h3 className="text-25 fw-600 pt-20">
                      {blogDetails?.Short_Description}
                    </h3>
                  </div>
                  <div className="row x-gap-20 font-inter">
                    <div className="col-auto">
                      <div className="text-left d-flex items-center py-10 x-gap-10">
                        <i className="far fa-calendar text-20 fw-600 text-primary"></i>
                        <div
                          className="text-14 fw-600 lh-1"
                          style={{ color: "#0E0E0E" }}
                        >
                          {blogDetails?.Created_On}
                        </div>
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="text-left d-flex items-center py-10 x-gap-10">
                        <i className="fas fa-running text-18 fw-600 text-primary"></i>
                        <div
                          className="text-14 fw-600 lh-1"
                          style={{ color: "#0E0E0E" }}
                        >
                          {blogDetails?.BlogType}
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-dark-1 text-14 lh-2 font-inter text-reading fw-500">
                    {blogDetails?.Long_Description}
                  </p>
                </div>
              </div>
            </div> */}
            </div>
          </section>
        </>
      )}
    </div>
  );
}

export default CategoryBlog;
